import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Tooltip
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import * as DATANETAPI from "../DataNet/DataNet";
import { Edit } from "@material-ui/icons";

const DeviceTrackerAssignmentForm = ({
  trackerImei,
  setTrackerImei,
  trackerSimMsisdn,
  isTrackerFormValid,
  setIsTrackerFormValid,
  formErrors,
  setFormErrors,
  hasEmtViewRole
}) => {
  const { t } = useTranslation();
  const phoneRegex = /^(\+34|34)?[6-9]\d{8}$/;
  const numericRegex = /^\d+$/;
  
  const handleImei = (event) => {
    setTrackerImei(event.target.value);
  };

  useEffect(() => {
    let imeiError = null;

    if (!trackerImei) {
      imeiError = t("account.error.empty");
      setIsTrackerFormValid(false);
    } else if (
      !numericRegex.test(trackerImei)
    ) {
      imeiError = t("devices.tracking.config.only_numbers");
    }

    setFormErrors((prev) => ({
      ...prev,
      trackerImei: imeiError
    }));

  }, [trackerImei]);
  
  return (
    <>
      <Grid item xs={12}>
        <Typography
          color="secondary"
          style={{
            fontWeight: 500,
            fontSize: 22,
            lineHeight: "30px",
            marginTop: 16
          }}
        >
          {t("devices.tracking.config.title")}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label={t("devices.tracking.config.imei")}
          placeholder={t("devices.tracking.config.imei")}
          variant="outlined"
          onChange={handleImei}
          value={trackerImei}
          inputProps={{
            maxLength: 15,
            ...(hasEmtViewRole && {
              style: { backgroundColor: "#f5f5f5", color: "#868686" }
            })
          }}
          error={!!formErrors.trackerImei}
          helperText={formErrors.trackerImei}
          InputLabelProps={{shrink: true}}
          disabled={hasEmtViewRole}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          value={trackerSimMsisdn}
          label={t("devices.tracking.config.phone")}
          placeholder={t("devices.tracking.config.phone")}
          variant="outlined"
          fullWidth
          helperText={formErrors.trackerSimMsisdn}
          InputProps={{ readOnly: true, style: { backgroundColor: "#f5f5f5", color: "#868686" }}}
          InputLabelProps={{shrink: true}}
        />
      </Grid>
    </>
  );
};

export default DeviceTrackerAssignmentForm;